import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "row"];

  connect() {
    this.updateBatchActions();
  }

  toggleAll(event) {
    const checked = event.target.checked;
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });
    this.updateBatchActions();
  }

  updateSelection() {
    // 更新全选框状态
    if (this.hasSelectAllTarget) {
      const allChecked = this.checkboxTargets.every((cb) => cb.checked);
      const someChecked = this.checkboxTargets.some((cb) => cb.checked);
      this.selectAllTarget.checked = allChecked;
      this.selectAllTarget.indeterminate = someChecked && !allChecked;
    }

    this.updateBatchActions();
  }

  updateBatchActions() {
    const selectedIds = this.getSelectedIds();
    const batchActionsDiv = document.getElementById("batch-actions");

    if (batchActionsDiv) {
      if (selectedIds.length > 0) {
        batchActionsDiv.style.display = "block";

        // 更新选中数量
        const countElement = batchActionsDiv.querySelector(
          "[data-batch-actions-target='count']",
        );
        if (countElement) {
          countElement.textContent = selectedIds.length;
        }

        // 更新所有表单的隐藏 account_ids 字段
        batchActionsDiv.querySelectorAll("form").forEach((form) => {
          // 移除旧的隐藏字段
          form
            .querySelectorAll("input[name='account_ids[]']")
            .forEach((input) => input.remove());

          // 添加新的隐藏字段
          selectedIds.forEach((id) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "account_ids[]";
            input.value = id;
            form.appendChild(input);
          });
        });
      } else {
        batchActionsDiv.style.display = "none";
      }
    }
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
  }
}
